import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { useEffect } from 'react';
import { useRouter } from 'next/router';
import { observer } from 'mobx-react-lite';
import { Button } from '../../form/button/button';
import { useRootStore } from '../../../../providers/root-store-provider';
import { IconPlus } from '../../icons/plus';
import { IconClose } from '../../icons/close';

export const HeaderPinSharedPortfolioButton: React.FC = observer(() => {
    const { t } = useTranslation();

    const rootStore = useRootStore();
    const { userStore, portfolioStore } = rootStore;

    const router = useRouter();
    const { shareSlug } = router.query;

    const isPinned = portfolioStore.pinnedPortfolios.some((p) => p.shareSlug === shareSlug);
    const isMyPortfolio = portfolioStore.portfolios.some((p) => p.shareSlug === shareSlug);

    useEffect(() => {
        portfolioStore.fetchPinnedPortfolios();
    }, [portfolioStore]);

    const handlePin = async () => {
        if (shareSlug) {
            if (isPinned) {
                await userStore.unpinPortfolio(shareSlug as string);
            } else {
                await userStore.pinPortfolio(shareSlug as string);
            }
        }
    };

    return isMyPortfolio ? null : (
        <Button
            size={{ xs: 'small', md: 'medium' }}
            icon={isPinned ? <IconClose /> : <IconPlus />}
            iconGap={'none'}
            iconPosition={'left'}
            hideLabelUnder={'md'}
            variant={'purple'}
            variation="outlined"
            onClick={handlePin}
        >
            {isPinned
                ? t('pages.app.sharedPortfolio.pin.unpinPortfolio')
                : t('pages.app.sharedPortfolio.pin.pinPortfolio')}
        </Button>
    );
});
